import {
  FingerprintIcon,
  KeyIcon,
  MessageSquareIcon,
  Phone2Icon,
  ShieldIcon,
} from '@newcore/icons';
import {
  FactorType,
  type FactorDefinition,
} from '@/features/onboarding/types/onboarding.types';

/**
 * Factor definitions with display info
 */
export const FACTOR_DEFINITIONS: Record<FactorType, FactorDefinition> = {
  [FactorType.PASSWORD]: {
    factorType: FactorType.PASSWORD,
    displayName: 'Password',
    description: 'Create a secure password for your account',
    icon: KeyIcon,
  },
  [FactorType.TOTP]: {
    factorType: FactorType.TOTP,
    displayName: 'Authenticator App',
    description: 'Use Google Authenticator, Authy, or similar app',
    icon: ShieldIcon,
  },
  [FactorType.SMS_OTP]: {
    factorType: FactorType.SMS_OTP,
    displayName: 'SMS',
    description: 'Receive one-time codes via text message',
    icon: Phone2Icon,
  },
  [FactorType.WHATSAPP_OTP]: {
    factorType: FactorType.WHATSAPP_OTP,
    displayName: 'WhatsApp',
    description: 'Receive one-time codes via WhatsApp',
    icon: MessageSquareIcon,
  },
  [FactorType.WEBAUTHN]: {
    factorType: FactorType.WEBAUTHN,
    displayName: 'Passkey',
    description: 'Use Touch ID, Face ID, or a hardware security key',
    icon: FingerprintIcon,
  },
  [FactorType.PUSH_NOTIFICATION]: {
    factorType: FactorType.PUSH_NOTIFICATION,
    displayName: 'NewCore App',
    description: 'Pair your mobile device with the NewCore App',
    icon: Phone2Icon,
  },
};

/**
 * OTP configuration
 */
export const OTP_LENGTH = 6;

/**
 * SMS resend configuration
 */
export const SMS_RESEND_COUNTDOWN_SECONDS = 30;
export const SMS_MAX_RESEND_COUNT = 3;

/**
 * Factor-specific error messages for verification failures
 */
export const FACTOR_ERROR_MESSAGES: Record<
  FactorType,
  {
    invalidCode: string;
    maxRetries: string;
    generic: string;
  }
> = {
  [FactorType.SMS_OTP]: {
    invalidCode: 'Invalid verification code. Please try again.',
    maxRetries: 'Too many failed attempts. Please request a new code.',
    generic: 'Verification failed. Please try again.',
  },
  [FactorType.WHATSAPP_OTP]: {
    invalidCode: 'Invalid verification code. Please try again.',
    maxRetries: 'Too many failed attempts. Please request a new code.',
    generic: 'Verification failed. Please try again.',
  },
  [FactorType.PASSWORD]: {
    invalidCode: 'Password setup failed. Please try again.',
    maxRetries: 'Too many failed attempts.',
    generic: 'Password setup failed. Please try again.',
  },
  [FactorType.TOTP]: {
    invalidCode: 'Invalid authenticator code. Please try again.',
    maxRetries: 'Too many failed attempts. Please scan the QR code again.',
    generic: 'Verification failed. Please try again.',
  },
  [FactorType.WEBAUTHN]: {
    invalidCode: 'Passkey verification failed.',
    maxRetries: 'Too many failed attempts.',
    generic: 'Passkey setup failed. Please try again.',
  },
  [FactorType.PUSH_NOTIFICATION]: {
    invalidCode: 'Device pairing failed.',
    maxRetries: 'Pairing session expired. Please try again.',
    generic: 'Device pairing failed. Please try again.',
  },
};
